/**
 * Fixed site copy (Global Constraints, verbatim) that client components also need. No imports, so a
 * 'use client' file can take these without pulling the catalogue or site facts into the browser bundle.
 */

/** Shown on every sample input photo (DESIGN.md "Do label every sample input photo"). */
export const INPUT_PHOTO_LABEL = 'Sample family (AI-generated photo)';

/** The promise (spec, verbatim): the home H1 and its title. */
export const PROMISE = 'Your family, drawn into their own storybook — from one photo.';

/** The main button (spec, verbatim). */
export const MAIN_CTA = "Preview your family's book free";

/** The header's short form of the main button (owner-approved 2026-11-03). */
export const MAIN_CTA_SHORT = 'Free preview';

/** The sub-line under the home hero's main button (owner-approved 2026-11-03, verbatim). */
export const HERO_CTA_SUBLINE = 'Add one photo. Your painted cover is ready in under a minute. No card, and you pay only if you order.';

/** The AI line, directly under the main button (spec, verbatim). */
export const AI_LINE = 'We use AI to draw your family from your photo, and you see the cover free before you pay.';
